// extracted by mini-css-extract-plugin
module.exports = {"score":"styles_score__2RdMA","blue":"styles_blue__MYj21","yellow":"styles_yellow__1yCvR","silver":"styles_silver__YIs2v"};